import React from "react";

import {
  ADD_NODE_GROUP_PROPERTIES,
  CREATABLE_NODE_PROPERTIES,
  getNodeTitle,
} from "src/constants/NodeProperties";
import { NodeTypeIcon as getNodeIcon } from "src/constants/NodeTypeIcons";
import { ADD_NODES_GROUPS, AddNodeGroupType } from "src/constants/NodeTypes";
import { AddNodeCard } from "src/nodeAdding/AddNodeCard";
import { SubPaneLayout } from "src/nodeAdding/SubPaneLayout";
import { AddNodeParams } from "src/store/GraphStore";

export type AddNodeGroupPaneProps = {
  addNode: (params: AddNodeParams) => void;
  groupType: AddNodeGroupType;
  onBackButtonClick: () => void;
  onCloseButtonClick: () => void;
};

export const AddNodeGroupPane: React.FC<AddNodeGroupPaneProps> = ({
  addNode,
  onCloseButtonClick,
  onBackButtonClick,
  groupType,
}) => {
  const nodes = ADD_NODES_GROUPS[groupType];
  return (
    <SubPaneLayout
      title={ADD_NODE_GROUP_PROPERTIES[groupType].HEADER}
      onBackButtonClick={onBackButtonClick}
      onCloseButtonClick={onCloseButtonClick}
    >
      <div>
        {nodes.map((node) => (
          <AddNodeCard
            key={node}
            dataLoc={`add-${node}`}
            description={CREATABLE_NODE_PROPERTIES[node].ADD_BUTTON_DESCRIPTION}
            infoBody={CREATABLE_NODE_PROPERTIES[node].INFO_BODY}
            infoTitle={CREATABLE_NODE_PROPERTIES[node].INFO_TITLE}
            isBeta={CREATABLE_NODE_PROPERTIES[node].IS_BETA}
            nodeIcon={getNodeIcon({ nodeType: node })}
            title={getNodeTitle({ nodeType: node })}
            onClick={() => addNode({ nodeType: node })}
          />
        ))}
      </div>
    </SubPaneLayout>
  );
};
